import { observer } from 'mobx-react';
import { T } from '../../../../../../../../../Translations';
import GroupAvatar from '../../../../../../../../Cutesies/GroupAvatar';
import { FilterOption } from './UseGroupDynamicTypeaheadSelect/Types';

interface Props {
  filterOption: FilterOption;
}

function FormattedOptionLabel({ filterOption }: Props) {
  return (
    <div className="flex px-1 py-1 justify-between items-center">
      <div className="flex items-center justify-between">
        <div className="w-8 h-8 mr-3 flex">
          <GroupAvatar />
        </div>
        <div className="flex flex-col">
          <div className="text-sm">{filterOption.label}</div>
          <div className="text-xs">
            <T kind="{{count}} Participant" count={filterOption.participantCount} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default observer(FormattedOptionLabel);
